// extracted by mini-css-extract-plugin
module.exports = {"editable":"FieldsW2Information_editable__NadiX","field":"FieldsW2Information_field__mBVtU"};